export default "__VITE_ASSET__31dd3363__"